import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../AuthContext";

const LogOut = () => {
    const navigate = useNavigate();
    const { LogOut } = useAuth();
    const apiUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!apiUrl) {
            console.error("L'URL de l'API n'est pas définie.");
            return;
        }

        const storedUser = localStorage.getItem("user");
        if (!storedUser) {
            LogOut();
            navigate("/");
            return;
        }

        const logOutUser = async () => {
            try {
                const response = await fetch(`${apiUrl}/log-out`, {
                    method: "POST",
                    credentials: "include",
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data?.message || "Problème lors de la déconnexion.");
                }

                LogOut();

                setTimeout(() => {
                    navigate("/");
                }, 500);

            } catch (error) {
                console.error("Erreur lors de la déconnexion:", error);
                setLoading(false);
            }
        };

        logOutUser();
    }, [LogOut, navigate, apiUrl]);

    return (
        <main>
            <Helmet>
                <title>Déconnexion - WinlyDeal</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <div style={{ textAlign: "center", marginTop: "50px", fontSize: "1.2rem" }}>
                {loading ? "Déconnexion en cours..." : "Redirection..."}
            </div>
        </main>
    );
};

export default LogOut;
